import api from 'utils/api';

export async function getStatistics(params) {
    const response = await api.get('statistic/total', { params });
    return response.data;
}

export async function getAnalytics(params) {
    const response = await api.get('statistic/analytics', { params });
    return response.data;
}
